<template>
    <div class="global_content" v-bind:class="this.dark ? 'dark' : ''">
        <div class="courses-layout">
            <div class="header-courses-row">
                <div class="title">
                    <p>Meus Cursos</p>
                </div>
                <div class="search-container">
                    <div class="search-input-wrapper">
                        <input
                            type="text"
                            v-model="search"
                            placeholder="Pesquisar curso..."
                            class="search-input"
                        />
                        <span class="search-icon">
                            <!-- SVG de lupa -->
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
                                <circle cx="9" cy="9" r="7" stroke="currentColor" stroke-width="2"/>
                                <line x1="14.2929" y1="14.7071" x2="18" y2="18.4142" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </span>
                    </div>
                </div>
            </div>
            <div class="courses" v-show="hasReady && user && user.type != null"> 
                <CourseCard
                    v-for="course in filteredCourses"
                    :key="course.course ? course.course.id : course.id"
                    :image="getCourseImage(course)"
                    :progress="course.course && course.course.progressPercentage != null ? (course.course.progressPercentage) : 0"
                    :title="course.course && course.course.name"
                    :id="user && user.type == 3 ? course.id : (course.course ? course.course.id : course.id)"
                    :status="course.course && course.course.status"
                    :data="course"
                    :invertOrder="true"
                ></CourseCard>
                <div v-if="filteredCourses.length === 0 && hasReady && user && user.type != null" class="no-results">
                    Nenhum curso encontrado.
                </div>
            </div>
            <span class="loader home" v-show="!hasReady || !user || user.type == null"></span>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader/loader.vue';
import CourseCard from './CourseCard.vue';
import { mapState } from 'vuex';


export default {
    data() {
        return {
            search: ''
        }
    },
    components: {
        CourseCard,
        Loader
    },
    computed: {
        ...mapState(['dark', 'user']),
        filteredCourses() {
            if (!this.data || !this.user || this.user.type == null) return [];
            if (!this.search) return this.data;
            const searchLower = this.search.toLowerCase();
            return this.data.filter(course => {
                const name = course.course && course.course.name ? course.course.name.toLowerCase() : '';
                return name.includes(searchLower);
            });
        }
    },
    methods: {
        getCourseImage(course) {
            if (!course || !course.course) return null;
            return course.course.imageFinalPath2 || course.course.imageFinalPath || null;
        }
    },
    props: {
        view: Boolean,
        data: Array,
        hasReady: Boolean
    },
}
</script>
<style>
.global_content {
    background-color: transparent;
    padding: 32px 0 8px;
}
.global_content.dark {
    background-color: transparent;
}

.global_content .courses {
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 24px;
    align-items: stretch;
}
.global_content .course {
    height: auto;
    min-height: 300px;
    max-width: none;
    background-repeat: no-repeat;
    position: relative;
    border-radius: 12px !important;
    cursor: pointer;
    background-size: cover;
    box-sizing: border-box;
    border: 1px solid var(--dash-border, rgba(15, 23, 42, 0.06));
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.global_content .course:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 32px rgba(15, 23, 42, 0.12);
}

.global_content.dark .course:hover {
    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.45);
} 

@media (max-width: 1024px) {
    .global_content .courses-layout {
        padding: 24px 0;
    }
    .global_content .courses {
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 20px;
    }
    .global_content .course {
        min-height: 280px;
    }
}

@media (max-width: 768px) {
    .global_content {
        padding: 16px 0 6px;
    }
    .global_content .courses-layout {
        padding: 12px 0;
    }
    .global_content .courses {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 16px;
    }
    .global_content .course {
        min-height: 260px;
    }
    .global_content .header-courses-row {
        flex-direction: column;
        align-items: stretch;
        gap: 10px;
        margin-bottom: 14px;
    }
    .global_content .title {
        width: 100%;
    }
    .global_content .title p {
        font-size: 19px;
    }
    .global_content .search-container {
        width: 100% !important;
        max-width: 100% !important;
        margin-top: 0;
        justify-content: stretch;
        display: flex;
    }
    .global_content .search-input-wrapper {
        width: 100%;
        max-width: 100%;
    }
}

@media (max-width: 480px) {
    .global_content {
        padding: 12px 0 4px;
    }
    .global_content .courses-layout {
        padding: 8px 0 !important;
    }
    .global_content .courses {
        grid-template-columns: 1fr;
        gap: 14px;
    }
    .global_content .course {
        min-height: 240px;
    }
    .global_content .title p {
        font-size: 17px;
        letter-spacing: -0.03em;
    }
    .global_content .search-input {
        font-size: 16px;
        padding: 11px 40px 11px 14px;
        min-height: 44px;
    }
    .global_content .no-results {
        font-size: 15px;
        margin-top: 20px;
    }
    .global_content .search-container {
        width: 100%;
        max-width: 100%;
        margin-top: 0;
        justify-content: stretch;
        display: flex;
    }
    .global_content .search-input-wrapper {
        width: 100% !important;
        max-width: 100% !important;
    }
    .global_content .header-courses-row {
        margin-bottom: 12px;
    }
}

.global_content .title{
    margin: 0;
}
.global_content .courses-layout {
    max-width: 1600px;
    padding: 0;
    margin: 0 auto;
    box-sizing: border-box;
}
.global_content .title p {
    color: var(--dash-text, #242424);
    font-family: Inter, system-ui, sans-serif;
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 1.25;
    letter-spacing: -0.02em;
}
.global_content .infos {
    position: absolute;
    width: 100%;
    bottom: 5%;
    text-align: left;
}
.global_content .progress_course {
    align-items: center;
    display: flex;
    padding: 0 10px;
    color: #b4b1ad;
    font-size: 12px;
}
.global_content .infos p {
    padding: 0 25px;
    overflow: hidden;
    color: #F3F3F3;
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 17px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.4px;
    margin: 0;
}
.global_content .progress_course {
    display: flex;
}
.global_content.dark .title p {
    color: var(--dash-text, #f3f4f6);
}
.global_content .loader.home {
    z-index: 999999;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 48px;
    height: 48px;
    border: 5px solid #1AC7D0;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}
.global_content .header-courses-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    margin-bottom: 20px;
}

.global_content .search-container {
    margin: 0;
    display: flex;
    justify-content: flex-end;
    width: 50%;
    max-width: 50%;
}
.global_content .search-input-wrapper {
    position: relative;
    width: 65%;
    display: flex;
    align-items: center;
}
.global_content .search-input {
    padding: 10px 42px 10px 16px;
    border: 1px solid var(--dash-border, #e5e7eb);
    border-radius: 10px;
    font-size: 15px;
    width: 100%;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
    box-sizing: border-box;
    background: var(--dash-bg-elevated, #fff);
    color: var(--dash-text, #111827);
}
.global_content.dark .search-input {
    background: var(--dash-bg-elevated, #1a191f);
    color: var(--dash-text, #f3f4f6);
    border-color: var(--dash-border, rgba(255, 255, 255, 0.12));
}
.global_content .search-input::placeholder {
    color: var(--dash-text-muted, #9ca3af);
}
.global_content .search-input:focus {
    border-color: #1ac7d0;
    box-shadow: 0 0 0 3px rgba(26, 199, 208, 0.2);
}
.global_content .search-icon {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    pointer-events: none;
    color: var(--dash-text-muted, #6b7280);
}
.global_content .no-results {
    width: 100%;
    text-align: center;
    color: var(--dash-text-muted, #888);
    font-size: 16px;
    margin-top: 40px;
}
.global_content .degrade {
    background: rgb(0, 0, 0);
    background: linear-gradient(0deg, rgb(16 16 16) 0%, rgba(0, 0, 0, 0.5858718487394958) 15%, rgba(0, 212, 255, 0) 83%);
    width: 100%;
    height: 335px!important;
    position: absolute;
    border-radius: 10px !important;
}
</style>